
<div class="d-flex align-items-center wrap-text">
  <span>{{ null !== entity.legalName ? entity.legalName : entity.name }}</span>
  <Badge :variant="entity.typeData().badge" class="ml-2">
    {{ entity.typeData().short }}
  </Badge>
</div>
